'use es6';

import createAction from 'flux-actions/createAction';
import { REQUESTED_CONTENT_USAGE_LIMITS, REQUESTED_CONTENT_USAGE_LIMITS_FAILED, RECEIVED_CONTENT_USAGE_LIMITS, REQUESTED_BLOG_USAGE_LIMITS, REQUESTED_BLOG_USAGE_LIMITS_FAILED, RECEIVED_BLOG_USAGE_LIMITS } from './ActionTypes';
export const requestedContentUsage = createAction(REQUESTED_CONTENT_USAGE_LIMITS);
export const receivedContentUsage = createAction(RECEIVED_CONTENT_USAGE_LIMITS, data => ({
  limit: data.limit || data.pageLimit,
  quantityUsed: data.quantityUsed
}));
export const receivedContentUsageFailure = createAction(REQUESTED_CONTENT_USAGE_LIMITS_FAILED, error => ({
  error
}));
export const requestedBlogUsage = createAction(REQUESTED_BLOG_USAGE_LIMITS);
export const receivedBlogUsage = createAction(RECEIVED_BLOG_USAGE_LIMITS, data => ({
  limit: data.limit,
  quantityUsed: data.quantityUsed
}));
export const receivedBlogUsageFailure = createAction(REQUESTED_BLOG_USAGE_LIMITS_FAILED, error => ({
  error
}));